import React from 'react'

interface WizardTextareaProps {
  label: string
  required?: boolean
  placeholder?: string
  value: string
  onChange: (value: string) => void
  maxLength?: number
}

const WizardTextarea = ({ label, required, placeholder, value, onChange, maxLength = 1000 }: WizardTextareaProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    <label style={{ fontSize: '0.875rem', fontWeight: 600, color: '#0a0d47' }}>
      {label}{required && <span style={{ color: '#ef4444', marginLeft: '2px' }}>*</span>}
    </label>
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      rows={5}
      style={{
        padding: '10px 14px',
        borderRadius: '8px',
        border: '1.5px solid #e5e7eb',
        fontSize: '0.875rem',
        color: '#374151',
        outline: 'none',
        resize: 'vertical',
        width: '100%',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
      }}
    />
    <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{value.length} / {maxLength} characters</span>
  </div>
)

export default WizardTextarea
